import React from 'react';
import { SurfaceLinkMenuContainer } from './style';
import LinkContextMenu from 'routes/surface/components/link-context-menu';
import {
  useLinkMenuPosition,
  useSelectedLink,
} from 'state/canvas/selected-link';
import { useCanvasStageScale } from 'state/canvas/stage';
import useCanvasLoading from 'components/canvas/hooks/use-canvas-loading';
import { useSpring } from 'react-spring';

export interface SurfaceLinkContextMenuProps {}

const defaultProps = {};

function SurfaceLinkContextMenu() {
  const [link] = useSelectedLink();

  const [linkMenuPosition] = useLinkMenuPosition();

  const scale = useCanvasStageScale();

  const { isLoading } = useCanvasLoading();

  const isVisible = link && linkMenuPosition;

  if (isLoading) {
    return null;
  }

  return (
    <SurfaceLinkMenuContainer isVisible={isVisible}>
      {isVisible && (
        <LinkContextMenu
          position={linkMenuPosition}
          scale={scale}
          link={link as any}
        />
      )}
    </SurfaceLinkMenuContainer>
  );
}

SurfaceLinkContextMenu.defaultProps = defaultProps;

export default SurfaceLinkContextMenu;
